import {
  Component,
  Input,
  AfterViewInit,
  OnChanges,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'lfx-dev-analytics-line-chart',
  templateUrl: './dev-analytics-line-chart.component.html',
  styleUrls: ['./dev-analytics-line-chart.component.scss'],
})
export class DevAnalyticsLineChartComponent
  implements AfterViewInit, OnChanges {
  @Input() chartColor: string;
  @Input() chartData: any;
  @Input() showLinechart: string;

  lineChart;
  @ViewChild('canvasId', { static: false }) canvas: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.chartData !== undefined) {
        this.createChart();
      }
    }, 500);
  }

  ngOnChanges() {
    if (this.lineChart !== undefined && this.lineChart !== null) {
      this.lineChart.data.datasets[0].hidden = !(this.showLinechart ===
        'contributors' || this.showLinechart === 'all'
        ? true
        : false);
      this.lineChart.data.datasets[1].hidden = !(this.showLinechart ===
        'contributions' || this.showLinechart === 'all'
        ? true
        : false);
      this.lineChart.update();
    }
  }

  createChart() {
    const canvas = this.canvas.nativeElement.getContext('2d');

    this.lineChart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        datasets: [
          {
            label: 'contributors',
            data: this.chartData.contributorList,
            borderColor: this.chartColor,
            backgroundColor: this.hexToRgb(this.chartColor, 0.2),
            fill: 'origin',
            borderWidth: 1,
            hidden: !(this.showLinechart === 'contributors' ||
            this.showLinechart === 'all'
              ? true
              : false),
          },
          {
            label: 'contributions',
            data: this.chartData.contributionList,
            borderColor: this.chartColor,
            borderWidth: 1,
            backgroundColor: this.hexToRgb(this.chartColor, 0.2),
            hidden: !(this.showLinechart === 'contributions' ||
            this.showLinechart === 'all'
              ? true
              : false),
          },
        ],
      },
      options: {
        lineHeightAnnotation: {
          always: false,
          hover: false,
          color: 'black',
          xAxis: 'x-axis-0',
          yAxis: 'y-axis-0',
          lineWeight: 1.5,
          // / sets shadow for ALL lines on the canvas
          shadow: {
            color: 'rgba(0,0,0,0.35)',
            blur: 10,
          },
        },
        legend: {
          display: false,
        },
        elements: { point: { radius: 0 } },
        responsive: false,
        scales: {
          yAxes: [
            {
              gridLines: {
                color: 'rgba(255, 255, 255, 0)',
                drawBorder: false,
                drawOnChartArea: false,
              },
              ticks: {
                display: false,
                max: this.getYAxiesMaxValue(),
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                color: 'rgba(255, 255, 255, 0)',
                drawBorder: false,
                drawOnChartArea: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
        },
      },
    });
  }

  getYAxiesMaxValue() {
    const graphArray = this.chartData.contributorList.concat(
      this.chartData.contributorList
    );

    return Math.max.apply(null, graphArray);
  }

  hexToRgb(hex, opacity) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return (
      'rgba( ' +
      parseInt(result[1], 16) +
      ',' +
      parseInt(result[2], 16) +
      ',' +
      parseInt(result[3], 16) +
      ',' +
      opacity +
      ')'
    );
  }
}
